import * as ActionTypes from '../constants/ActionTypes';

export function navigate(url, search) {
    return { type: ActionTypes.NAVIGATE, url, search };
}

export function invalidateForm() {
    return { type: ActionTypes.INVALIDATE_FORM };
}

export function validateForm() {
    return { type: ActionTypes.VALIDATE_FORM };
}

export function invalidSubmit() {
    return { type: ActionTypes.INVALID_SUBMIT };
}

export function validSubmit() {
    return { type: ActionTypes.VALID_SUBMIT };
}




// WEBPACK FOOTER //
// ./src/actions/navigationActions.js